import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBVatNumberSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="vatNumber"
            formName="vatNumber"
            label="vatNumber"
        />
    )
}

export default CBVatNumberSearchFilter;